export default {
    // Sidebar
    'Nova OS Proativa':  'New Proactive WO',
    'Interno':  'Internal',
    'Externo':  "External",
    'Preventiva':  "Preventive",
    'Preventiva Programada':  "Scheduled Preventive",
    "Preventiva Programada Armazém": "Scheduled Preventive Warehouse",
    'Reaberta':  "Reopened",
    'Execuções':  "Executions",
    'Armazém':  "Warehouse",
    'Frota':  "Fleet",
    'Sair':  "Logout",
    'Inventário':  "Inventory",

    // Nova Os
    'Voltar':  "Back",
    'Nova OS':  "New WO",
    'Operação':  "Operation",
    'Placa':  "Plate",
    'Segmento':  "Segment",
    'Problemas':  "Issues",
    'Descrição do Problema':  "Issue Description",
    'Gerar OS':  "Generate WO",
    'Cancelar':  "Cancel",

    // OS Interna
    "Nenhum resultado encontrado": "No results found",
    "Exibindo resultado": "Showing result",
    "de": "of",
    "Aberta há": "Open for",
    "Concluída em": "Completed on",
    "Falha ao carregar os dados da OS": "Failed to load WO data",
    "Falha ao carregar os itens da OS": "Failed to load WO items",

    // Ordem Servico
    "Detalhes": "Details",
    "Mostrar": "Show",
    "Esconder": "Hide",
    "Telefone": "Phone",
    "Data": "Date",
    "Início": "Start",
    "Final": "End",
    "Fornecedor": "Supplier",
    "Tipo": "Type",
    "Ciclo preventiva": "Preventive cycle",
    "Criticidade": "Criticality",
    "Previsão de Atendimento": "Estimated Service Time",
    "Atendimento do Item": "Item Service",
    "Observações": "Notes",
    "Imagens": "Images",
    "Salvar": "Save",
    "Ordens de Serviço": "Work Orders",
    "GERADA_CHECKLIST": "GENERATED FROM CHECKLIST",
    "OBS_CHECKLIST": "CHECKLIST NOTES:",
    "OS_INTERNA": "INTERNAL WO:",

    // OS Item
    "Iniciar": "Start",
    "Ações": "Actions",
    "Continuar": "Continue",
    "Pausar": "Pause",
    "Registrar Peças": "Register Parts",
    "Cancelar OS": "Cancel WO",
    "OS Externa": "External WO",
    "Insira um serviço. Tente novamente.": "Insert a service. Try again.",
    "Esta Ordem de Serviço já foi encerrada no GINFO. O atendimento não pode mais ser alterado.": "This Work Order has already been closed in GINFO. The service can no longer be modified.",
    "Somente Consulta": "Read Only",
    "Ordem de Serviço Encerrada": "Work Order Closed",
    "Ordem de Serviço Cancelada": "Work Order Canceled",

    // ModalItems
    "Serviços": "Services",
    "SERVIÇOS": 'SERVICES',
    "Observação": "Note",
    "Anexo de arquivos": "File attachment",
    "Oops!": "Oops!",
    "Tipo de arquivo não permitido.": "File type not allowed.",
    "Vídeo muito grande": "Video too large",
    "O limite para anexos de vídeo é de 20MB. Grave um vídeo mais curto ou reduza a qualidade antes de anexar.": "The limit for video attachments is 20MB. Record a shorter video or reduce the quality before attaching it.",
    "Informe o valor total dos serviços/peças": "Enter the total value of services/parts",
    "Informe o motivo do socorro em rota": "Enter the reason for roadside assistance",
    "Informe o pneu utilizado neste serviço": "Enter the tire used in this service",
    "Foi trocado o pneu": "Was the tire replaced",
    "Finalizar OS": "Finish WO",

    // Modal se foi utilizado peças
    "Foi utilizado Peças?": "Were parts used?",
    'Se foi utilizado peças neste atendimento, pressione "Sim" na opção abaixo!': "If parts were used in this service, press 'Yes' below!",
    "Não": "No",
    "Sim": "Yes",

    // Modal Itens Fim
    "Informe os itens utilizados neste serviço": "Enter the items used in this service",
    "Fechar": "Close",
    "Peças": "Parts",
    "Peça": "Part",
    "Quantidade": "Quantity",
    "Qtde": "Qty",
    "Localização": "Location",
    "Não informado": "Not specified",
    "Preço": "Price",
    "Informe o pneu novo": "Enter the new tire",
    
    //Modal Pause
    "Informe a Justificativa": "Enter the justification",
    "Confirmar Pausa": "Confirm Pause",
    "Justificativa": 'Justification',
    "Ir ao banheiro": 'Bathroom break',
    "Fim de expediente": 'End of shift',
    "Atendimento": 'Service',
    "Refeição": 'Meal break',
    "Aguardando Peças": 'Waiting for parts',
    "Auxílio externo": 'External assistance',
    'Selecione qual peça está aguardando': 'Select which part is pending',

    // Confirmar OS Externa
    "Confirmar OS Externa": "Confirm External WO",
    "Deseja realmente enviar OS": "Do you really want to submit the WO",
    "Confirmar": "Confirm",

    // Lista de Execucao
    "Lista de execução": "Execution List",
    "Nenhuma execução ativa": "No active executions",
    "Início Atendimento": "Start Service",
    "Encerrar OS": "Close WO",
    "Acessar OS": "Access WO",
    "Colaborador": "Employee",
    "Execuções em Pause": "Paused Executions",
    "Nenhuma execução em pause": "No paused executions",

    // Login
    "Torne sua rotina mais dinâmica": "Make your routine more dynamic",
    "ACESSO AO SISTEMA": "SYSTEM ACCESS",
    "Terminal Oficina": "Workshop Terminal",
    "Realize o login e tenha acesso ao controle": "Log in and access control",
    "e gestão de suas Ordens de Serviço": "and management of your Work Orders",
    "Mecânico Externo": "External Mechanic",
    "Acessar": "Access",
    "Falha ao fazer login": "Login failed",

    // Filtro Internas
    "Ordenar": "Sort",
    "Antigas Primeiro": "Oldest First",
    "Recentes Primeiro": "Newest First",
    "Maior": "Higher",
    "Menor": "Lower",
    "Segmentos": "Segments",
    "Período": "Period",
    "Execução": "Execution",
    "Todos": "All",
    "Pendentes": "Pending",
    "Finalizadas": "Completed",
    "Aplicar filtro": "Apply filter",
    "Limpar filtros": "Clear filters",
    "Esconder filtros": "Hide filters",
    "Criado por": "Created by",
    "Usuário": "User",
    "Ação": "Action",

    // Os Preventivas
    "Filtre as OS Preventivas": "Filter Preventive WOs",
    "Preventivas Vencidas": "Overdue Preventives",
    "Preventivas à Vencer": "Upcoming Preventives",
    "Carrocerias Vencidas": "Overdue Bodyworks",
    "Atualizar": "Refresh",

    // Modais Preventivas
    "ACAO": "ACTION",
    "PLACA": "PLATE",
    "PROXIMO_CICLO": "NEXT_CYCLE",
    "VENCIMENTO": "DUE_DATE",
    "PROXIMO_KM": "NEXT_KM",
    "KM_ATUAL": "CURRENT_KM",
    "Vincular Fornecedor": "Link Supplier",
    
    // Inventário
    "Não contados": "Not counted",
    "Contados": "Counted",
    "Ordenação": "Sorting",
    "Total Itens": "Total Items",
    "Status": "Status",
    "Inventário criado com sucesso!": "Inventory created successfully!",
    "Já existe um inventário em execução": "An inventory is already in progress",
    "Deseja iniciar um novo inventário?": "Do you want to start a new inventory?",
    "Inventário de Estoque": "Stock Inventory",

    // Modal Mecanico
    "Informe os três primeiros dígitos do seu CPF para confirmar sua identidade":
        "Enter the first three digits of your CPF to confirm your identity",
    'Confirmar identidade': 'Confirm identity',

    "Erro do Motorista": "Driver Error",
    "Defeito não Encontrado": "Defect Not Found",

    "Informe o serviço": "Enter the service",
    "Insira os Itens": "Insert the Items",

    "Alterar Fornecedor": "Change Supplier",
    "Preventivas Armazém": "Warehouse Preventives",
    "Outros": "Others",
    "Ver Encerradas": "View Closed",
    "Tem dúvida?": "Any questions?",
    "Nenhuma OS aguardando aprovação": "No WO awaiting approval",
    "Aguardando Aprovação": "Awaiting Approval",

    "OS Preventivas Vencidas": "Overdue Preventive WOs",
    "OS Encerradas - Últimas 15 OS": "Closed WOs - Last 15",
    "DATA": 'DATE',

    'Precisa de Ajuda?': 'Need Help?',
    'Desejamos um ótimo 2024!': 'We wish you a great 2024!',
    
    'Bem vindo(a) ao Terminal da Borracharia!': 'Welcome to the Tire Shop Terminal!',
    'Realize a gestão de pneus pelo novo terminal da borracharia!':
        'Manage tires through the new tire shop terminal!',
    'Aderência Aferição 01': 'Grip Measurement 01',
    'Aderência Aferição 02': 'Grip Measurement 02',
    'de Calibragem': 'of Calibration',
    'Aferição': 'Measurement',
    'Movimentação/Troca': 'Movement/Replacement',
    'Descarte': 'Disposal',
    'Serviço': 'Service',
    'Borracharia': 'Tire Shop',
    'Placas': 'Plates',

    'AÇÃO': 'ACTION',
    'TIPO': 'TYPE',
    'CONJUNTO': 'SET',
    'AFERIÇÃO': 'MEASUREMENT',

    'Selecione um Pneu': 'Select a Tire',
    'Informar KM': 'Enter KM',
    'Informar Aferição': 'Enter Measurement',
    'Aferindo NR Fogo': 'Measuring Fire Code',
    'Última Aferição': 'Last Measurement',
    'Novas Aferições': 'New Measurements',
    'Última aferição NR fogo': 'Last Fire Code Measurement',
    'Registrar Aferições': 'Register Measurements',
    'Realizar avaliação': 'Perform evaluation',
    'Preditiva': 'Predictive',
    'Externas Armazém': 'External Warehouse',
    'Carrocerias à Vencer': 'Upcoming Bodyworks',
    
    'Problema': 'Issue',
    'Pendente': 'Pending',
    'Descartes': 'Disposals',
    
    'OS Preditiva': 'Predictive WO',
    'Gerar OS Preditiva': 'Generate Predictive WO',
    'Iniciar novo inventário': 'Start new inventory',
    'Dt Inicial': 'Start Date',
    'Dt Final': 'End Date',

    "Fora do Prazo": "Overdue",
    "Dentro do Prazo": "On Time",

    "CALIBRAGEM": "CALIBRATION",
    "Nunca feito": "Never done",
    "FOGO": "FIRE",
    "Informar Calibragem": "Enter Calibration",
    "Comece a digitar o nome do fornecedor para exibir na lista abaixo":
    "Start typing the supplier name to display in the list below",

    "Portugues": "Portuguese",
    "Mercosul": "Mercosur",
    "Ingles": "English",
    'Frances': "French",
    'Alemao': 'German',
    'Holandes': 'Dutch',
    'Espanhol': 'Spanish',

    
    "O ESFORÇO DE HOJE É O SUCESSO DE AMANHA": "TODAY'S EFFORT IS TOMORROW'S SUCCESS",

    // Daqui para baixo deve ser jogado nos demais arquivos

    "CODIGO OS": "CODE WO",
    "TODOS": "ALL",
    "Socorro em Rota pendente de atendimento": "Emergency service pending response",
    "FILTROS": "FILTERS",
    "Salvar Filtro": "Save Filter",
    "Motorista": "Driver",
    "Orçamento": "Budget",
    "Confirmar Orçamento": "Confirm Budget",
    "Deseja pausar esta OS para aguardar o orçamento?": "Do you want to pause this work order to await the quote?",
    "Valor": 'Value',
    "Pausar OS": 'Pause WO',
    "Comentarios": 'Comments',
    "Insira um comentário": 'Enter a comment',
    "Enviar OS": 'Send WO',
    "Selecione uma justificativa": 'Select a justification',
    "Anexos": 'Attachments',
    "OS Socorro em Rotas": 'Roadside Assistance',
    "Confirmar Cancelamento": 'Confirm Cancellation',
    "Buscar Placa": 'Search Plate',
    "Pesquisa de OS por placa": 'OS search by motherboard',
    "CONTRATO_CONCESSIONARIA": "CONCESSIONAIRE CONTRACT",
    
    "Ordem gerada com sucesso": "Order generated successfully",
    "Sucesso": "Success",
    "Selecionar Todos": "Select All",
    "Descrição": "Description",
    "Registrar Serviços": "Register Services",
    "Visualizar Itens": "View Items",
    "Clique no botão a direita para registrar as peças": "Click the button on the right to register the parts",
    
    "Selecionar técnico": "Select technician",
    "KM atual/Horimetro": "Current mileage/Hour meter",
    "Deseja inserir alguma imagem no atendimento": "Do you want to add an image to the service",
    "Para concluir a ação, selecione abaixo o técnico responsável": "To complete the action, select the responsible technician below.",
    "Trabalhando": "Working",
    "Matricula": "Registration",
    "Serviços registrado com sucesso": "Services successfully registered",
    "Função": "Function",
    "Enviar Anexos": "Send Attachments",
    "Gerar Preventiva Programada": "Generate Scheduled Preventive Maintenance",
    "OS Preventiva Programada": "Scheduled Preventive Care",
    "Finalize todas as peças e serviços para encerrar o atendimento": "Complete all parts and services to close the service order",
    "Insira um KM maior que o anterior": "Enter a kilometer higher than the previous one",
    "Insira um KM maior que o atual": "Enter a kilometer value greater than the current value",
    "Inserir anexos": "Insert attachments",
    "Planos Preventivos": "Preventive Plans",
    "Filtro": "Filter",
    "ULTIMA": "LAST",
    "Gerar Preditiva": "Generate Preventive",
    "Carregando": "Loading",
    "OS Preventiva Programada Armazém": "Scheduled Preventive Maintenance Warehouse",
    "Gerar OS Preventiva Programada": "Generate Scheduled Preventive Work Order",
    "OS Preventivas à Vencer": "Preventive Measures to Overcome",
    "OS de Transição": "Transition WO",

    "IMEDIATA": "IMMEDIATE",
    "EMERGENCIAL": "EMERGENCY",
    "ALTA": "HIGH",
    "MÉDIA": "MEDIUM",
    "LEVE": "LOW",

    "Registrar Tarefas": "Register Tasks",
    "Desbloqueia Empilhadeira": "Unlock Forklift",
    "OS Ag. Aprovação": "WO Pending Approval",
    "OS Internas Veículos": "Internal WO – Vehicles",
    "OS Internas Armazém": "Internal WO – Warehouse",
    "OS Reabertas": "Reopened WO",
    "Criticidade de OS Abertas": "Criticality of Open WO",
    "Top 20 Placas com mais OS": "Top 20 License Plates with Most WO",
    "Qtd OS": "WO Quantity",

    // Dashboard
    "Criticidade de OS abertas": "Open WO Criticality",
    "URGENTE": "URGENT",
    "PREVENTIVA": "PREVENTIVE",
    "CRITICIDADES": "CRITICALITIES",
    "Bem Vindo(a)": "Welcome",
    "Tenha acesso as principais": "Get access to the main",
    "informações da sua mecânica!": "information about your workshop!",
    "Ver OS internas": "View Internal WO",
    "OS TicketLog": "TicketLog WO",
    "OS Externas": "External WO",
    "OS Interna Veículos": "Internal WO Vehicles",
    "OS Interna Armazém": "Internal WO Warehouse",
    "Ranking dos Mecânicos": "Mechanic Ranking",
    "Tipo de OS": "WO Type",
    "Atendidas nos últimos 30 dias": "Served in the last 30 days",
    "TOP 20 Placas com mais OS": "TOP 20 Plates with Most WO",
    "Últimos 30 dias": "Last 30 days",
    "Placas com OS Externas": "Plates with External WO",
    "TOP 10 Problemas mais atendidos": "TOP 10 Most Attended Issues",
    "Nos últimos 30 dias": "In the last 30 days",
    "Status por Mecânico": "Status by Mechanic",
    "Produtividade": "Productivity",

    // ModalEncerradas
    "Filtros": "Filters",
    "NÚMERO": "NUMBER",
    "INÍCIO": "START",
    "FINAL": "END",
    "SEGMENTO": "SEGMENT",
    "PROBLEMA": "ISSUE",

    // Login
    "Acesso Rápido": "Quick Access",
    "ID": "ID",
    "CNPJ": "ID",
    "codigo_fornec": "code",
    "Para qual fornecedor você deseja enviar esta OS": "Which supplier would you like to send this order to",

    "DS_PREDITIVO": "PREVENTIVE DESCRIPTION",
    "FILTRO EMPRESA": "COMPANY FILTER",
    "Upload Arquivos": "Upload Files",
    "Cards": "Cards",
    "Colunas": "Columns",
    "ULTIMA MM": "LAST MM",
    "PRÓXIMA MM": "NEXT MM",
    "ULTIMA CAL": "LAST CAL",
    "PRÓXIMA CAL": "NEXT CAL",

    "ULTIMA MOVIMENTACAO": "LAST MOVEMENT", 
    "PRÓXIMA MOVIMENTACAO": "NEXT MOVEMENT",
    "N° FOGO": "FIRE CODE",
    "FILIAL": "BRANCH",
    "MARCA": "BRAND",
    "MEDIDA": "MEASURE",
    "MODELO": "MODEL",
    "POSIÇÃO": "POSITION",

    "Aguardando Aprovação de Sinistro": "Claim Approval Awaited",
    "Aguardando Liberacao": "Awaiting Release",
    "Nenhuma OS aguardando liberacao": "No work order awaiting release",

    "O tempo total é inferior a 5 minutos. Isso poderá impactar negativamente no controle de gestão": 
    "The total time is less than 5 minutes. This may negatively impact management control",
    "Aguardar Liberação": "Awaiting Release",

    // Chaves adicionadas para i18n completo
    "Adicionar Serviços": "Add Services",
    "CD_PNEU": "TIRE_CODE",
    "CPF (3 primeiros digitos)": "CPF (first 3 digits)",
    "Cadastro": "Registration",
    "Calibragem NR Fogo": "Fire No. Calibration",
    "Confirmar envio Ticket": "Confirm Ticket Submission",
    "Conserto de Pneus": "Tire Repair",
    "DashBoard": "Dashboard",
    "Dashboard": "Dashboard",
    "Data Final": "End Date",
    "Data Inicial": "Start Date",
    "Data OS": "WO Date",
    "Descartar": "Discard",
    "Descarte Pneus": "Tire Disposal",
    "Deseja enviar para TicketLog a OS": "Do you want to send the WO to TicketLog",
    "Digite para pesquisar": "Type to search",
    "Enviar": "Send",
    "Equipamento Liberado": "Equipment Released",
    "Escreva seu script aqui": "Write your script here",
    "Informar Sinistro": "Report Claim",
    "Informe o KM do Pneu": "Enter Tire KM",
    "Informe o serviço feito!": "Enter the service performed!",
    "Insira o KM do veículo:": "Enter the vehicle KM:",
    "Insira os Serviços": "Insert Services",
    "Inventário de estoque": "Stock Inventory",
    "Inverter pneus": "Swap tires",
    "Início Atendimento OS": "WO Service Start",
    "Item": "Item",
    "Itens:": "Items:",
    "KM": "KM",
    "KM PROX.": "NEXT KM",
    "Lançamento de item": "Item Entry",
    "Lista": "List",
    "Matrícula": "Registration",
    "Motivo": "Reason",
    "NR Fogo": "Fire No.",
    "OS Preventiva Vencida": "Overdue Preventive WO",
    "Observacao": "Note",
    "PROX. CICLO": "NEXT CYCLE",
    "Para qual fornecedor você deseja enviar esta OS?": "Which supplier do you want to send this WO to?",
    "Pesquisa global": "Global search",
    "Pesquisar": "Search",
    "Pesquisar Item": "Search Item",
    "Pesquisar peça": "Search part",
    "Pesquisar serviço": "Search service",
    "Planos": "Plans",
    "Pneus a Placa:": "Tires for Plate:",
    "Próximo Ciclo": "Next Cycle",
    "Pular": "Skip",
    "Selecione a empresa": "Select the company",
    "Selecione um fornecedor": "Select a supplier",
    "Selecione um motivo": "Select a reason",
    "Servicos": "Services",
    "Sinalizar Sinistro": "Flag Claim",
    "Sucesso!": "Success!",
    "Vencimento": "Due Date",
    "Adicionar Arquivos": "Add Files",
    "Ordem de Serviço criada com Sucesso": "Work Order created successfully",
    "Falha ao parar execução. Tente novamente": "Failed to stop execution. Please try again.",
"Selecionar": "Select",
"Insira todas as informações": "Enter all the information",
"Item registrado com sucesso": "Item successfully registered",
"Item atualizado com sucesso": "Item successfully updated",
"Insira um preço": "Enter a price",
"OS Preventiva A Vencer": "Preventive Work Orders Due Soon",
"OS já está aberta": "The work order is already open",
"Não trabalhando": "Not working",
"ABASTECIMENTO": "REFUELING",
"CHECKLIST": "CHECKLIST",
"CHECKLIST CONFORMIDADE": "COMPLIANCE CHECKLIST",
"PREVENTIVA CARROCERIA": "BODYWORK PREVENTIVE MAINTENANCE",
"SOCORRO EM ROTA": "ROADSIDE ASSISTANCE",
"finalizado": "Finished",
"contagem": "Count",
"contagem_de_itens": "Item Count",
"codigo": "Code",
"saldo_atual": "Current Balance",
"item_nao_registrado_tente_novamente": "Item not registered, please try again",
"versao": "Version",
"informe_a_leitura_de_todos_os_sulcos": "Enter the reading of all tread grooves",
"Faça a leitura de todos os pneus para registrar": "Read all tires to register them",
"Leitura registrada com sucesso": "Reading registered successfully",


    // Anexos do descarte de pneus
    "Anexar documento": "Attach document",
    "Selecione o tipo do documento e o arquivo para anexar ao descarte": "Select the document type and the file to attach to the disposal",
    "Tipo de documento": "Document type",
    "Selecione um anexo": "Select an attachment",
    "Adicionar documento": "Add document",
    "Extensão não permitida": "Extension not allowed",
    "Arquivo excede o tamanho máximo de": "File exceeds the maximum size of",
    "Informe o tipo do documento": "Enter the document type",
    "Descarte realizado, mas falhou o envio dos anexos": "Disposal completed, but the attachments could not be sent",
    "Descarte realizado com sucesso!": "Disposal completed successfully!",
    "Erro ao descartar pneu, tente novamente!": "Error disposing of the tire, please try again!",
    "Informe o KM atual!": "Enter the current mileage!",

    "Selecione um Fornecedor": "Select a Supplier",
    "Preencha todas as informações": "Fill in all the information",
    "Origem": "Origin",
    "Interna": "Internal",
    "Externa": "External",

  "CORRETIVA": "CORRECTIVE",
  "REFORMA": "OVERHAUL",
  "Informações sobre OS": "Work order details",
  "SERVIÇO": "SERVICE",
  "PEÇA": "PART",
  "Sem execução": "No execution",
  "Atenção!": "Warning!",
  "Situação": "Status",
  "Carroceria": "Trailer",
  "Cavalo": "Tractor unit",
  "24 HORAS": "24 HOURS",
  "48 HORAS": "48 HOURS",
  "72 HORAS": "72 HOURS",
  "4 HORAS (HORÁRIO COMERCIAL)": "4 HOURS (BUSINESS HOURS)",
  "Falha ao pausar execução. Tente novamente.": "Failed to pause the execution. Please try again.",
  "Falha ao cancelar execução. Tente novamente.": "Failed to cancel the execution. Please try again.",
  "Informe uma justificativa": "Please provide a justification",
  "Informe uma nota": "Please provide a rating",
  "Informe uma peça": "Please select a part",
  "Informe o KM atual": "Please enter the current mileage",
  "Informe uma aferição menor que a atual!": "Please enter a measurement lower than the current one!",
  "Insira todas as informações!": "Please fill in all the information!",
  "Insira um anexo para registrar o sinistro!": "Please attach a file to register the incident!",
  "Ordem gerada com sucesso!": "Order generated successfully!",
  "Selecione um fornecedor!": "Please select a supplier!",
  "Selecione todos os serviços!": "Please select all services!",
  "Selecione um motivo!": "Please select a reason!",
  "Selecione um serviço!": "Please select a service!",
  "Serviço realizado com sucesso!": "Service completed successfully!",
  "Erro ao enviar pneu para serviço, tente novamente!": "Error sending the tire for service, please try again!",
  "Qual é o tipo de OS?": "What is the work order type?",
  "Você deseja direcionar esta OS como externa ou como interna?": "Do you want to route this work order as external or internal?",
  "Pneu vinculado com sucesso!": "Tire linked successfully!",
  "Esta Ordem de Serviço está cancelada no GINFO. O atendimento não pode mais ser alterado.": "This work order is cancelled in GINFO. It can no longer be changed.",
  "Existem posições sem pneu aplicado!": "There are positions without a tire fitted!",
  "Entre no menu Movimentações e aplique os pneus deste caminhão.": "Go to the Movements menu and fit the tires for this truck.",
  "Layout": "Layout",
  "Meus Atendimentos": "My work orders",
  "Seu usuário não tem permissão para criar OS Proativa!": "Your user is not allowed to create a proactive work order!",
  "SLA": "SLA",
  "Ciclo": "Cycle",
  "Mecânico": "Mechanic",
  "Suas Avaliações": "Your ratings",
  "Avaliação referente as OS atendidas nos últimos 30 dias.": "Rating for the work orders handled in the last 30 days.",
  "Nota": "Rating",
  "Nota selecionada": "Selected rating",
  "Opcional": "Optional",
  "Horas Trabalhadas": "Hours worked",
  "Qtd": "Qty",
  "Página em manutenção": "Page under maintenance",
  "A página de OS de empilhadeira está em desenvolvimento": "The forklift work order page is under development",
  "A página de OS de transpaleteira está em desenvolvimento": "The pallet truck work order page is under development",
  "Preenchimento obrigatório": "This field is required",
  "Disponível": "Available",
  "Deve ser maior que 0": "Must be greater than 0",
  "Não pode ser negativo": "Cannot be negative",
  "Valor Unitário": "Unit price",
  "Existem filtros salvos e aplicados": "There are saved filters applied",
  "Já existe um atendimento em andamento para esta OS e este técnico.": "There is already an ongoing service for this work order and this technician.",
  "Falha ao validar a situação do atendimento. Tente novamente.": "Failed to validate the service status. Please try again.",
  "Falha ao iniciar o atendimento. Tente novamente.": "Failed to start the service. Please try again.",
  "Falha ao encerrar o atendimento. Tente novamente.": "Failed to close the service. Please try again.",
}
